import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Import the TSX file explicitly to avoid resolving to any existing App.js
import App from "./App.tsx";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { UserProvider } from "context/UserContext";
import { HostPortalProvider } from "context/HostPortalContext";
import { NavigationMessageContextProvider } from "context/NavigationMessageContext.tsx";
import { AlertProvider } from "context/AlertContext.tsx";

const container = document.getElementById("app") as HTMLElement | null;
if (!container) {
  throw new Error("No #app element found");
}
const root = createRoot(container);

root.render(
  <BrowserRouter>
        <UserProvider>
          <HostPortalProvider>
            <NavigationMessageContextProvider>
              <MaterialUIControllerProvider>
                <AlertProvider>
                  <App />
                </AlertProvider>
              </MaterialUIControllerProvider>
            </NavigationMessageContextProvider>
          </HostPortalProvider>
        </UserProvider>
  </BrowserRouter>
);
